module.exports = __webpack_public_path__ + "img/profile-placeholder.0956e3a2.jpg";